/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_TitleInputs */

const en_us2_swap_title = /** @type {(inputs: Swap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swap exercise`)
};

const pt_br2_swap_title = /** @type {(inputs: Swap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar exercício`)
};

const es_419_swap_title = /** @type {(inputs: Swap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar ejercicio`)
};

const pt_pt2_swap_title = /** @type {(inputs: Swap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar exercício`)
};

const fr_fr2_swap_title = /** @type {(inputs: Swap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer d'exercice`)
};

const de_de2_swap_title = /** @type {(inputs: Swap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übung tauschen`)
};

const it_it2_swap_title = /** @type {(inputs: Swap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia esercizio`)
};

/**
* | output |
* | --- |
* | "Swap exercise" |
*
* @param {Swap_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_title = /** @type {((inputs?: Swap_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_title(inputs)
	if (locale === "es-419") return es_419_swap_title(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_title(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_title(inputs)
	if (locale === "de-DE") return de_de2_swap_title(inputs)
	if (locale === "it-IT") return it_it2_swap_title(inputs)
	return en_us2_swap_title(inputs)
});
export { swap_title as "swap.title" }